import type { MappedRequest } from "../ImagesPage";
import { COMPACT_THRESHOLD, ImageCard } from "./ImageCard";

type ImagesGridProps = {
  requests: MappedRequest[];
  imageSize: number;
  onSelect?: (request: MappedRequest) => void;
  selectedId?: string;
};

export function ImagesGrid({
  requests,
  imageSize,
  onSelect,
  selectedId,
}: ImagesGridProps) {
  const isCompact = imageSize < COMPACT_THRESHOLD;
  const minWidth = isCompact
    ? Math.round(80 + (imageSize - 30) * 1.2)
    : Math.round(120 + (imageSize - 30) * 1.8);

  return (
    <div
      className="images-grid w-full overflow-visible p-1"
      style={{
        gridTemplateColumns: `repeat(auto-fill, minmax(min(100%, ${minWidth}px), 1fr))`,
        gap: isCompact ? "0.75rem" : "0.5rem",
      }}
    >
      {requests.map((request, index) => (
        <ImageCard
          createdAt={request.createdAt}
          isCompact={isCompact}
          isSelected={selectedId === request._id}
          key={`${request._id}-${index}`}
          onClick={() => onSelect?.(request)}
          previewUrl={request.previewUrl}
          promptText={request.promptText}
          stage={request.stage}
        />
      ))}
    </div>
  );
}
